module.exports = __webpack_public_path__ + "img/icon-table-close.7fb1544f.svg";